export const faq = () => {
  let i = 1;
  $('.faq-count').each(function () {
    let countText = '';
    if (i < 10) {
      countText = ' 0' + i;
    } else {
      countText = ' ' + i;
    }
    countText = $(this).text() + countText;
    $(this).text(countText);
    i++;
  });
};
